import { BaseModal } from 'shared/ui/BaseModal';
import { Button } from 'shared/ui/Button';

import { ContainerSC, TextSC } from './styled';

type Props = {
  visible: boolean;
};

export const UpdateAppPopup = ({ visible }: Props) => (
  <BaseModal isOpen={visible} disable onClose={() => null} maxWidth='300px'>
    <ContainerSC>
      <TextSC>Что-то новенькое!</TextSC>
      <Button onClick={() => window.location.reload()}>Обновить приложение</Button>
    </ContainerSC>
  </BaseModal>
);
